module.exports = __webpack_public_path__ + "static/media/rush_bookmark_plan-a_2x.19aef3fc.jpg";